import { Container, Row } from "reactstrap";
import WelcomeBanner from "./WelcomeBanner";
import ClientAndEarningCard from "./ClientAndEarningCard";
import SellOverview from "./SellOverview";
import Analysis from "./Analysis";
import Order from "./Order";
import Appointment from "./Appointment";
import MonthlyOverview from "./MonthlyOverview";
import ActivityTimeline from "./ActivityTimeline";
import ProductRevenue from "./ProductRevenue";
import BeyoDetails from "./BeyoDetails";

const DefaultDashboardContainer = () => {
  return (
    <Container fluid className="default-dashboard">
      <Row>
        <WelcomeBanner />
        <ClientAndEarningCard />
        <SellOverview />
        <Analysis />
        <Order />
        <Appointment />
        <MonthlyOverview />
        <ActivityTimeline />
        <ProductRevenue/>
        <BeyoDetails/>
      </Row>
    </Container>
  );
};

export default DefaultDashboardContainer;
